module Main
  ( main
  )
  where

import Prelude

import Control.Monad.Error.Class (liftEither)
import Data.Bifunctor (lmap)
import Effect (Effect)
import Effect.Class (liftEffect)
import Effect.Exception (error)
import Halogen.Aff as HA
import Halogen.VDom.Driver (runUI)
import Visonum.BulkPingApp.Components.App as App
import Visonum.BulkPingApp.StaticConfig (getStaticConfig)

main :: Effect Unit
main = HA.runHalogenAff do
  body <- HA.awaitBody
  staticConfig <- 
     getStaticConfig
       # liftEffect
       # map (lmap error)
       >>= liftEither
       
  _ <- runUI App.component {staticConfig} body
  pure unit